import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty, get, isNil } from 'lodash-es';

import { config } from 'config';
import {
  getUploadVideoIsUnsupportedSelector,
  getUploadVideoObjectSelector,
  SelectVideoView,
  UNSUPPORTED_FILE_DIALOG,
  uploadFormConfigRequestAction,
  uploadFormConfigSelector,
  uploadInitVideoObjectRequestAction,
} from 'pages/upload.page';
import { FIELDS } from 'components/forms';
import { showDialogAction } from 'components/redux-dialog/actions';

const SelectVideo = (props) => {
  const { isPodcast, uploadFormConfig, tocForm, fetchUploadFormConfig } = props;
  const [showBlockUi, setShowBlockUi] = useState(true);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (isNil(uploadFormConfig)) {
      fetchUploadFormConfig();
    } else {
      setShowBlockUi(false);
      setIsValid(true);
    }
  }, [uploadFormConfig, fetchUploadFormConfig]);

  useEffect(() => {
    if (isNil(uploadFormConfig)) {
      return;
    }

    const textField = getUploadFieldConfig(uploadFormConfig);
    const confirmationRequired = get(textField, 'config.required', false);
    let isValid = true;

    if (confirmationRequired) {
      const confirmCheckBoxChecked = getConfirmCheckBoxValue(tocForm) === true;

      isValid = confirmCheckBoxChecked;
    }

    setShowBlockUi(false);
    setIsValid(isValid);
  }, [uploadFormConfig, tocForm]);

  const getConfirmCheckBoxValue = (tocForm) => tocForm && !isEmpty(tocForm.values) && tocForm.values[FIELDS.TEXT_BOX];

  const getUploadFieldConfig = (config) => config.find((field) => field.type === FIELDS.TEXT_BOX);

  const uploadFile = (file) => {
    const fileIsSupported = isPodcast
      ? config.upload.supportedAudioFileExtensions.indexOf(file.type) > -1
      : config.upload.supportedVideoFileExtensions.indexOf(file.type) > -1;

    if (fileIsSupported) {
      setShowBlockUi(true);
      props.uploadVideo(file);
    } else {
      setShowBlockUi(false);
      props.showDialog();
    }
  };

  const handleUploadVideoClick = () => {
    const fileInput = document.getElementById('select-file-hidden-input');
    fileInput.addEventListener('change', (evt) => uploadFile(evt.target.files[0]), false);
    fileInput.click();
  };

  const handleFileDrop = (files) => {
    if (files.length > 0) {
      uploadFile(files[0]);
    }
  };

  return (
    <SelectVideoView
      isPodcast={isPodcast}
      showBlockUi={showBlockUi}
      isValid={isValid}
      onDrop={handleFileDrop}
      uploadButtonClickHandler={handleUploadVideoClick}
    />
  );
};

export const SelectVideoDecorated = connect(
  (state) => ({
    uploadVideoObject: getUploadVideoObjectSelector(state),
    videoIsUnsupported: getUploadVideoIsUnsupportedSelector(state),
    uploadFormConfig: uploadFormConfigSelector(state),
    tocForm: state.form.uploadTocForm,
  }),
  (dispatch) => ({
    uploadVideo: (file) => dispatch(uploadInitVideoObjectRequestAction(file)),
    fetchUploadFormConfig: () => dispatch(uploadFormConfigRequestAction()),
    showDialog: () => dispatch(showDialogAction(UNSUPPORTED_FILE_DIALOG)),
  })
)(SelectVideo);

export * from './view';
export * from './fragments/iframe-nav-bar';
export * from './fragments/unsupported-file-dialog';
export * from './fragments/drop-zone';
export * from './fragments/toc';
